<template>
  <v-layout>
    <div class="detail-layout">
      <div class="detail-title">
        <span>수수료지급명세표 상세</span>
      </div>

      <div class="detail-table-layout">
        <table>
          <thead>
            <tr>
              <th>기준모집인번호</th>
              <th>실적월</th>
              <th>모집인번호</th>
              <th>팀</th>
              <th>모집인성명</th>
              <th>본부장</th>
              <th>관리팀장</th>
              <th>영업팀장</th>
              <th>취급점명</th>
              <th>담보종류</th>
              <th>대출금액</th>
              <th>수수료총액</th>
              <th>vat제외</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(row, index) in detailList" :key="index">
              <td>{{ setLoanBrokerNoFormat(row.managementMgrId) }}</td>
              <td>{{ row.baseYm }}</td>
              <td>{{ setLoanBrokerNoFormat(row.loanBrokerNo) }}</td>
              <td>{{ row.orgNm }}</td>
              <td>{{ row.agentName }}</td>
              <td>{{ row.headMgrNm }}</td>
              <td>{{ row.managementMgrNm }}</td>
              <td>{{ row.salesMgrNm }}</td>
              <td>{{ row.branchNm }}</td>
              <td>{{ row.collateralType }}</td>
              <td class="text-right">{{ inputComma(row.loanAmount) }}</td>
              <td class="text-right">{{ inputComma(row.feeTotal) }}</td>
              <td class="text-right">{{ inputComma(row.commissionNet) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-layout>
</template>
<script>
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "PaymentDetailList",
  props: ["detailList"],
  mixins: [TableMixin],
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.detail-layout {
  border: 2px solid #222222;
  width: 100%;
  height: 75vh;
  margin: 5px auto;
  padding: 5mm;
  box-sizing: border-box; /* 패딩과 테두리를 포함하여 210x297mm 유지 */
  display: flex;
  flex-direction: column; /* 제목, 날짜, 테이블을 세로로 정렬 */
  overflow: hidden; /* 영역 밖으로 나가는 테이블을 숨김 (인쇄용일 경우) */
  .detail-title {
    flex-shrink: 0; /* 제목 영역은 줄어들지 않음 */
    margin-bottom: 10px;

    span {
      font-size: 1.15rem;
      font-weight: 700;
    }
  }
  .detail-table-layout {
    flex: 1;
    width: 100%;
    overflow: auto;
    border: 1px solid #eeeeee;
    table {
      table-layout: auto;
      width: max-content;
      min-width: 100%;
      border-collapse: collapse;
      thead th {
        position: sticky;
        top: 0;
        background-color: #f8f8f8;
        z-index: 1;
        outline: 1px solid #222222;
      }
      tr {
        th,
        td {
          border: 1px solid #222222;
          padding: 8px 12px;
          white-space: nowrap;
          font-size: 0.85rem;
          text-align: center;
        }
      }
    }
  }
}
</style>